import styles from '../index.module.scss';
import { Link } from 'react-router';
import { isMobile } from 'react-device-detect';

export const LoginLink = () => {
  if (isMobile) {
    return null;
  }

  return (
    <div className="leading-5 text-sm font-normal text-neutrals-n-400 text-center flex items-center flex-wrap ">
      <span>Already have an account? </span>
      <Link to={`/login`} className={styles.link}>
        Log in
      </Link>
    </div>
  );
};
